import Ajv from "ajv";

import { lvtResponseSchema } from "../common";


const unitHealthPropertiesSchema = {
    color: { type: "string" },
    isFlapping: { type: "boolean" },
    isGradient: { type: "boolean" },
    overlay: { type: ["string", "null"] },
    startColor: { type: "string" },
    statusText: { type: "string" },
};

const cameraInformationPropertiesSchema = {
    id: { type: "number" },
    name: { type: ["string", "null"] },
    thumbnailPreset: { type: ["number", "null"] },
};

const liveUnitMetadataProperties = {
    accessArchives: { type: "boolean" },
    accessStream: { type: "boolean" },
    cameraList: {
        type: "array",
        items: {
            type: "object",
            additionalProperties: true,
            required: Object.keys(cameraInformationPropertiesSchema),
            properties: cameraInformationPropertiesSchema,
        },
    },
    clientId: { type: "number" },
    clientName: { type: ["string", "null"] },
    liveUnitId: { type: "number" },
    liveUnitName: { type: "string" },
    liveUnitSerial: { type: ["string", "null"] },
    locationCity: { type: ["string", "null"] },
    locationId: { type: "number" },
    locationName: { type: "string" },
    locationState: { type: ["string", "null"] },
    locationStreet: { type: ["string", "null"] },
    locationZip: { type: ["string", "null"] },
    unitHealth: {
        type: "object",
        additionalProperties: false,
        required: Object.keys(unitHealthPropertiesSchema),
        properties: unitHealthPropertiesSchema,
    },
};

const liveUnitMetadataSchema = {
    type: "object",
    additionalProperties: false,
    required: Object.keys(liveUnitMetadataProperties),
    properties: liveUnitMetadataProperties,
};

const liveUnitInfoProperties = {
    showClientNameStreamPage: { type: "boolean" },
    showClientNameHistoryPage: { type: "boolean" },
    liveUnitSerialNum: { type: ["string", "null"] },
    clientId: { type: "number" },
    clientName: { type: ["string", "null"] },
    liveUnitId: { type: "number" },
    liveUnitName: { type: "string" },
    locationId: { type: "number" },
    locationName: { type: "string" },
};

const liveUnitInfoSchema = {
    type: "object",
    additionalProperties: false,
    required: Object.keys(liveUnitInfoProperties),
    properties: liveUnitInfoProperties,
};

export const liveUnitMetadataValidator = new Ajv().compile(liveUnitMetadataSchema);

const lvtResponseLiveUnitMetadataSchema = lvtResponseSchema(liveUnitMetadataSchema);

export const lvtResponseLiveUnitMetadataValidator = new Ajv().compile(lvtResponseLiveUnitMetadataSchema);


export const liveUnitInfoValidator = new Ajv().compile(liveUnitInfoSchema);

const lvtResponseLiveUnitInfoSchema = lvtResponseSchema(liveUnitInfoSchema);

export const lvtResponseLiveUnitInfoValidator = new Ajv().compile(lvtResponseLiveUnitInfoSchema);
